/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetMeQueryResponse,
  GetMe401,
  GetMe404,
  GetMe500,
} from "../types/GetMe.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getMeQueryKey = () => [{ url: "/me" }] as const;

export type GetMeQueryKey = ReturnType<typeof getMeQueryKey>;

/**
 * @description Возвращает:
 * - Базовую информацию (username, displayName, email, avatar)
 * - Роли пользователя (Admin, SiteAdmin, Moderator, Tester)
 * - Привязанные OAuth аккаунты
 * - Riot аккаунты
 * - Настройки профиля
 * - Статистику
 * Используется для отображения профиля в навигации/настройках.
 * @summary Получить полный профиль текущего авторизованного пользователя
 * {@link /me}
 */
export async function getMe(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetMeQueryResponse,
    ResponseErrorConfig<GetMe401 | GetMe404 | GetMe500>,
    unknown
  >({ method: "GET", url: `/me`, ...requestConfig });
  return res;
}

export function getMeQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getMeQueryKey();
  return queryOptions<
    ResponseConfig<GetMeQueryResponse>,
    ResponseErrorConfig<GetMe401 | GetMe404 | GetMe500>,
    ResponseConfig<GetMeQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getMe({ ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * @description Возвращает:
 * - Базовую информацию (username, displayName, email, avatar)
 * - Роли пользователя (Admin, SiteAdmin, Moderator, Tester)
 * - Привязанные OAuth аккаунты
 * - Riot аккаунты
 * - Настройки профиля
 * - Статистику
 * Используется для отображения профиля в навигации/настройках.
 * @summary Получить полный профиль текущего авторизованного пользователя
 * {@link /me}
 */
export function useGetMe<
  TData = ResponseConfig<GetMeQueryResponse>,
  TQueryData = ResponseConfig<GetMeQueryResponse>,
  TQueryKey extends QueryKey = GetMeQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetMeQueryResponse>,
        ResponseErrorConfig<GetMe401 | GetMe404 | GetMe500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getMeQueryKey();

  const query = useQuery(
    {
      ...getMeQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetMe401 | GetMe404 | GetMe500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
